import { graphql, useFragment } from 'react-relay';
import { isV2Auction } from './isV2Auction.ts';
import { isV1Auction } from './isV1Auction.ts';
import { type useIsPrimarySale_nftItem$key } from './__generated__/useIsPrimarySale_nftItem.graphql.ts';

export const useIsPrimarySale = ({
    nftItem: nftItemRef = null,
}: {
    nftItem?: useIsPrimarySale_nftItem$key | null | undefined;
}): boolean => {
    const nftItem = useFragment(
        graphql`
            fragment useIsPrimarySale_nftItem on NftItem {
                contract {
                    addressWithFields {
                        owner {
                            address
                        }
                    }
                }
                creatorAddress {
                    address
                }
                ownerAddress {
                    address
                }
                lastLiveAuction: mostRecentAuction(excludeCanceled: true) {
                    sellerAddress {
                        address
                    }
                }
            }
        `,
        nftItemRef
    );

    const contractOwner = nftItem?.contract?.addressWithFields?.owner?.address?.toLowerCase();
    const tokenCreator = nftItem?.creatorAddress?.address?.toLowerCase();
    const tokenOwner = nftItem?.ownerAddress?.address?.toLowerCase();
    const mostRecentSeller = nftItem?.lastLiveAuction?.sellerAddress?.address?.toLowerCase();

    if (isV1Auction(tokenOwner) || isV2Auction(tokenOwner)) {
        return mostRecentSeller === contractOwner || mostRecentSeller === tokenCreator;
    }

    return tokenOwner === contractOwner || tokenOwner === tokenCreator;
};
